import React from 'react';
import { Col, Row } from 'reactstrap';

import LinkCard from './linkCard';

class LinkCardsView extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnMessageClick = this.handleOnMessageClick.bind(this);
  }

  handleOnMessageClick = () => {
    window.Intercom('showMessages');
  };

  render() {
    return (
      <Row className="m-0 link-cards-row">
        <Col xs={12} sm={6}>
          <Row className="m-0">
            <Col xs={6}>
              <LinkCard
                onClick={this.handleOnMessageClick}
                iconClass="icon-message"
                description="Message Our Team"
              />
            </Col>
            <Col xs={6}>
              <a
                href="https://intercom.help/promotionwingman/en/collections/19673572-general-support"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkCard
                  iconClass="icon-question"
                  description="Frequently Asked Questions"
                />
              </a>
            </Col>
          </Row>
        </Col>
        <Col xs={12} sm={6}>
          <Row className="m-0">
            <Col xs={6} className="">
              <a
                href="https://intercom.help/promotionwingman-support/en/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkCard
                  iconClass="icon-study2"
                  description="Support Articles"
                />
              </a>
            </Col>
            <Col xs={6}>
              <a
                href="https://kaplan.com/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkCard
                  iconClass="icon-document"
                  description="Privacy Policy"
                />
              </a>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}
export default LinkCardsView;
